export enum TaskCriticalities {
	All = 'ALL',
	Critical = 'critical',
	Warning = 'warning',
	Transparent = 'transparent',
}
